import { atom } from 'jotai';
import type { MessageDescriptor } from 'react-intl';
import { navV3Messages } from '../nav-v3.messages';
import type { RecentItem } from './merge-recent-items';

export type RecentsFilter = 'all' | 'chats' | 'encounters';

/** Survives sidebar remounts; resets on full reload. */
export const recentsFilterAtom = atom<RecentsFilter>('all');

export const RECENTS_FILTER_OPTIONS: RecentsFilter[] = ['all', 'chats', 'encounters'];

export const RECENTS_FILTER_MESSAGES: Record<RecentsFilter, MessageDescriptor> = {
  all: navV3Messages.filterAll,
  chats: navV3Messages.filterChats,
  encounters: navV3Messages.filterEncounters,
};

export const matchesRecentsFilter = (
  item: RecentItem,
  filter: RecentsFilter
): boolean => {
  if (filter === 'all') return true;
  return filter === 'chats' ? item.kind === 'chat' : item.kind === 'visit';
};
